import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const SyringeOutline = createIcon({
  displayName: 'SyringeOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M13.33,8.24l4.16,-4.16"></path>
        <path d="M20.01,6.6l-4.15,4.16"></path>
        <path d="M10.95,5.86l7.3,7.29"></path>
        <path d="M6.65,17.45l-3.65,3.65"></path>
        <path d="M7.38,12.35l1.46,1.46"></path>
        <path d="M9.57,10.16l1.46,1.46"></path>
        <path d="M16.45,3.04l4.55,4.55"></path>
        <path d="M16.845,11.748l-6.537,6.537c-0.781,0.781 -2.047,0.781 -2.828,0l-1.607,-1.605c-0.781,-0.781 -0.781,-2.047 0,-2.828l6.537,-6.537"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const SyringeTwoTone = createIcon({
  displayName: 'SyringeTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="g"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
        color="twoToneStrokeColor"
      >
        <Box
          as="path"
          fill="twoToneLightColor"
          d="M16.845,11.748l-6.537,6.537c-0.781,0.781 -2.047,0.781 -2.828,0l-1.607,-1.605c-0.781,-0.781 -0.781,-2.047 0,-2.828l6.537,-6.537"
        ></Box>
        <path d="M13.33,8.24l4.16,-4.16"></path>
        <path d="M20.01,6.6l-4.15,4.16"></path>
        <path d="M10.95,5.86l7.3,7.29"></path>
        <path d="M6.65,17.45l-3.65,3.65"></path>
        <path d="M7.38,12.35l1.46,1.46"></path>
        <path d="M9.57,10.16l1.46,1.46"></path>
        <path d="M16.45,3.04l4.55,4.55"></path>
      </Box>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const Syringe: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={SyringeTwoTone} {...props} />

  return <CustomIcon as={SyringeOutline} {...props} />
}

export default memo(Syringe)
